export default __webpack_public_path__ + "static/media/jobInfo@2x.ec0d2c53.webp";